import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styles from './ComingSoonOverlay.module.scss'

export default function ComingSoonOverlay({ gap = null }) {
  const isLicenseRequired = gap?.reason === 'reason.license_required'

  return (
    <div className={`${styles.overlay} position-absolute d-grid`}>
      <div className={`${styles.card} d-flex align-items-start`}>
        <i className="fa-regular fa-clock" aria-hidden="true" />
        <div>
          <div className={styles.title}>
            <FormattedMessage id="AI_RISK_REPORT.COMING_SOON_OVERLAY.TITLE" />
          </div>
          <div className={styles.body}>
            <FormattedMessage
              id={
                isLicenseRequired
                  ? 'AI_RISK_REPORT.COMING_SOON_OVERLAY.LICENSE_BODY'
                  : 'AI_RISK_REPORT.COMING_SOON_OVERLAY.BODY'
              }
            />
          </div>
        </div>
      </div>
    </div>
  )
}

ComingSoonOverlay.propTypes = {
  gap: PropTypes.shape({ reason: PropTypes.string }),
}
